import api from "@/config/api";
import { useAdmin } from "@/context/admin";
import { useTable } from "@/context/table";
import { Product } from "@/types/entities";
import { log } from "@/utils/logger";
import { isDefined } from "@/utils/validations";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

const useQueryProducts = (orgId?: string, brandId?: string) => {
    const authenticated = useAdmin(state => state.authenticated);
    const { oid, bid } = useParams();

    const organizationID = orgId || oid;
    const brandID = brandId || bid;

    const enabled = authenticated && isDefined(organizationID) && isDefined(brandID);

    const { filterModel, paginationModel, sortModel } = useTable();

    const { pageSize, page } = paginationModel;
    const { field, sort } = sortModel;

    const getProducts = async () => {
        try {
            const endpoint = `/organizations/${organizationID}/brands/${brandID}/products?page=${page}&pageSize=${pageSize}&sortField=${field}&sortDirection=${sort}`;

            const data = await api.get<Array<Product>>(endpoint);
            return data;
        } catch (e) {
            log.error(e);
        }
    };

    return useQuery({
        queryKey: ["products", brandID, page, filterModel, sortModel],
        queryFn: getProducts,
        enabled,
    });
};

export default useQueryProducts;
